import { useScroll } from 'Utils/useScroll';

export default (hasForm, openModal) => () => (!!hasForm ? useScroll('inline-form') : openModal());
